import Link from "next/link";
import React from "react";
import { MdClose } from "react-icons/md";

export default function RegistrationAlert({
  showAlert,
  alertMessage,
  alertStatus,
  closeAlert,
  registeredURL,
  registeredSerial,
  children,
}) {
  if (!showAlert) {
    return null;
  }

  return (
    <div className="alert-wrapper">
      <div className="alert-box">
        <div className="alert-head">
          <div>
            {alertStatus || "Error"}
            {registeredSerial && <> | Registered serial: {registeredSerial}</>}
          </div>
          <div onClick={closeAlert}>
            <MdClose />
          </div>
        </div>

        <div className="alert-content">
          {children ?? (
            <p>
              {alertMessage ||
                "Thank you for your registration. If you are seeing this, something went wrong. Please contact us to verify your registration."}
            </p>
          )}

          {registeredURL && (
            <Link href={registeredURL} target="_blank">
              View Printer Friendly Version
            </Link>
          )}

          <button type="button" onClick={closeAlert}>
            Continue
          </button>
        </div>
      </div>
    </div>
  );
}
